<template>
  <div class="planning-button">
    <v-btn class="planning-button__button" v-bind="$attrs" v-on="listeners">
      {{ $t('PLANNINGS.PLANNINGS_BUTTON') }}
    </v-btn>

    <v-messages
      :value="errorMessages"
      :class="['planning-button__messages', { 'error--text': hasErrors }]"
    ></v-messages>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PlanningButton',

  props: {
    day: {
      type: [String, Array, Object, Date],
      default: () => ({}),
      validator: prop => moment(prop).isValid()
    },
    order: {
      type: [String, Number],
      default: null
    },
    employees: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    formattedDay() {
      const day = moment(this.day).isValid() ? this.day : undefined;

      return moment(day).format(moment.HTML5_FMT.DATE);
    },
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        click: this.to
      });
    },
    hasErrors() {
      return this.errorMessages.length;
    }
  },

  methods: {
    to() {
      this.clearCached();
      this.$router.push({
        name: 'plannings',
        query: {
          day: this.formattedDay,
          order: this.order,
          employees: this.employees
        }
      });
    },

    clearCached() {
      this.$store.cache.delete('planning/getOrdersList');
      this.$store.cache.delete('planning/getEmployeesList');
    }
  }
};
</script>

<style lang="scss" scoped>
.planning-button {
  &__button {
    margin-bottom: 8px;
  }
}
</style>
